import React from "react"
import connect from "./connect"
import QuickLink from "../BurgerQuickLink"
import {QUICKLINK_TYPE, BURGER_QUICKLINK_TYPE} from "../../config/constants"
import configRelativePathURL from "../../utils/configUrlPath"

type QuickLinkProps = {
    text: string | null
    icon: string | null
    url: string | null
    accessibilityText: string
    description: string | null
}

export type BurgerPrimaryNavProps = {
    quickLinks: QuickLinkProps[] | undefined
    siteUrl: string
}

const Links = ({quickLinks, siteUrl}: BurgerPrimaryNavProps) => {
    const hideBadge = true
    return (
        <div>
            {quickLinks &&
                quickLinks.map(q => {
                    if (q.url && q.text) {
                        return (
                            <QuickLink
                                key={q.accessibilityText}
                                href={configRelativePathURL(q.url, siteUrl)}
                                iconSrc={q.icon}
                                iconAltText={q.accessibilityText}
                                title={q.text}
                                description={q.description || ""}
                                type={QUICKLINK_TYPE.LINK}
                                linkType={BURGER_QUICKLINK_TYPE.LINKS}
                                hideBadge={hideBadge}
                            />
                        )
                    }
                    return null
                })}
        </div>
    )
}

export const BurgerQuickLinks = ({quickLinks, siteUrl}: BurgerPrimaryNavProps) => {
    const props = {quickLinks, siteUrl}
    return quickLinks && quickLinks.length > 0 ? <Links {...props} /> : null
}
export default connect(BurgerQuickLinks)
